import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const BarGraph: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path fill='none' d='M0 0h24v24H0z' />
      <path
        d='M21 18.25v1.5H3v-1.5zM6.75 12h-1.5v4h1.5zm12-8h-1.5v12h1.5zm-8 3h-1.5v9h1.5zm4 3h-1.5v6h1.5z'
        fill='currentColor'
      />
    </svg>
  </i>
);

BarGraph.displayName = 'BarGraph';
export default BarGraph;
